module.exports = __webpack_public_path__ + "img/img15.f5b557c4.svg";